const l = {
  name: "ArrowSmall",
  dimensions: { width: 40, height: 26 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 25.6" style="enable-background:new 0 0 40 25.6;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,0l20,20l-5.7,5.7L20,11.3L5.7,25.6L0,20L20,0z M2.8,20l2.8,2.8L20,8.5l14.3,14.3l2.8-2.8L20,2.8L2.8,20z"
			/>
	</g>
</g>
</svg>
  `
};
export {
  l as ArrowSmall
};
